import './scss/sounds-nav';

requirejs(['istats-1'], istats => {
  const logoLink = document.getElementById('sn__logo-link');
  const listenLink = document.getElementById('sn__listen-link');
  const mySoundsLink = document.getElementById('sn__my-sounds-link');

  istats.track('internal', {
    region: logoLink,
    linkLocation: 'sounds-nav-logo'
  });

  istats.track('internal', {
    region: listenLink,
    linkLocation: 'sounds-nav-listen'
  });

  istats.track('internal', {
    region: mySoundsLink,
    linkLocation: 'sounds-nav-mysounds'
  });
});
